<template>
    <menu-layout>
        <menu-header
            prefix="level-select"
            :badge="t('LEVEL_SELECT_BADGE')"
            :title-main="t('LEVEL_SELECT_TITLE_MAIN')"
            :title-accent="t('LEVEL_SELECT_TITLE_ACCENT')"
        >
            <template #actions>
                <profile-menu/>
            </template>
        </menu-header>
        <div class="content">
            <p class="objective cr-m0" data-testing="level-select-objective">{{ t('LEVEL_SELECT_OBJECTIVE') }}</p>
            <div class="levels cr-p4 cr-m0">
                <level-card
                    v-for="(level, index) in levels"
                    :key="index"
                    :data-testing="`level-select-level-${index + 1}`"
                    :label="`${level.namePrefix} - ${level.nameSuffix}`"
                    :description="level.shortDescription"
                    :image-src="level.happyImageSrc"
                    :score="getScoreForLevel(level)"
                    :threshold="level.completionThreshold"
                    :to="{ name: Route.LevelSelectPlay.name, params: { mission: index + 1 } }"
                />
            </div>
        </div>
    </menu-layout>
</template>

<style scoped>
.levels
{
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
}
</style>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Route from '../../routers/route';
import MenuHeader from '../MenuHeader.vue';
import LevelCard from '../LevelCard.vue';
import MenuLayout from '../layouts/MenuLayout.vue';
import ProfileMenu from '../ProfileMenu.vue';
import { useLevelStore } from '../../stores/levelStore';
import { useScoreStore } from '../../stores/scoreStore';
import ChallengeCategoryPrefix from '../../interfaces/challengeCategoryPrefix';
import ILevel from '../../interfaces/iLevel';
import { usePageTitle } from '../../composables/usePageTitle';

const { t } = useI18n();
const levelStore = useLevelStore();
const scoreStore = useScoreStore();
const levels = levelStore.levels;

usePageTitle(computed(() => [{ text: t('PAGE_TITLE_LEVEL_SELECT') }]));

function getScoreForLevel(level: ILevel): number
{
    return scoreStore.getScoreForCategory(`${ChallengeCategoryPrefix.LevelPick}${level.categorySuffix}`);
}
</script>
